"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var set_year_1 = require("./set-year");
/**
 * @hidden
 */
exports.normalizeYear = function (value, year) { return (set_year_1.setYear(value, year(value.getFullYear()))); };



//////////////////
// WEBPACK FOOTER
// /Users/larsmarin/Documents/Workspaces/AAG/aag-amc-projects/~/.pnpm/@progress+kendo-date-math@1.5.14/~/@progress/kendo-date-math/dist/npm/normalize-year.js
// module id = 118
// module chunks = 0